/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Row_HintInputs */



/**
* | output |
* | --- |
* | "Each row needs a promo and a non-zero quantity." |
*
* @param {Promo_Movement_Row_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_row_hint = /** @type {((inputs?: Promo_Movement_Row_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Row_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chaque ligne doit avoir une promo et une quantité non nulle.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cada fila necesita una promo y una cantidad distinta de cero.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cada linha precisa de uma promo e uma quantidade diferente de zero.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ogni riga deve avere una promo e una quantità diversa da zero.")
	return /** @type {LocalizedString} */ ("Each row needs a promo and a non-zero quantity.")
});